import ActionTypes from './actionTypes';

export const clearError = () => dispatch => dispatch({ type: ActionTypes.CLEAR_ERROR });
